export enum FIN_NFE {
    "NORMAL" = 1,
    "COMPLEMENTAR" = 2,
    "AJUSTE" = 3,
    "DEVOLUCAO" = 4,
    "NOTA DE CRÉDITO" = 5,
    "NOTA DE DÉBITO" = 6
}